module.exports = __webpack_public_path__ + "static/media/sslc.41c88ab9.png";